<template>
	<MainLayout>
		<div class="container">
			<b-card no-body>
				<b-tabs
					no-fade
					pills
					card
					small
					vertical
					nav-class="nav-style"
				>
					<b-tab title="Usuarios General" active>
						<b-button v-if="$hasPermission('user.add')" class="float-right" @click="newUser('core')">Nuevo usuario</b-button>
						<h2>Usuarios</h2>
						<hr>
						<b-form
							@submit="(evt) => { evt.preventDefault(); this.$root.$emit('bv::refresh::table', 'users-index-list') } ">
							<div class="row">
								<b-form-group class="col-2" label="Buscar">
									<b-form-input v-model="coreAppFilters.search" type="text"/>
								</b-form-group>
								<b-form-group class="col-2" label=".">
									<b-button type="submit" variant="primary">Buscar</b-button>
								</b-form-group>
							</div>
						</b-form>
						<AjaxTable
							permission-show="user.show"
							id="users-index-list"
							:filters="coreAppFilters"
							:columns="usersColumns"
							resource="users"
							responsive
						>
							<template v-slot:cell(actions)="row">
								<div class="text-center">
									<b-button  @click="() => editUser(row.item.id, 'core')" type="button" size="sm" class="mr-1" variant="info">
										<md-icon icon="edit"/>
									</b-button>
									<b-button v-if="$hasPermission('user.delete')" @click="(event) => userDelete(row.item,row.index,event)" type="button" size="sm" class="mr-1" variant="danger">
										<md-icon icon="delete"/>
									</b-button>
								</div>
							</template>
						</AjaxTable>
					</b-tab>

					<b-tab title="Usuarios SASS">
						<b-button v-if="$hasPermission('usersass.add')" class="float-right" @click="newUser('sass')">Nuevo usuario</b-button>
						<h2>Usuarios App SASS</h2>
						<b-alert class="mt-3" show>
							<md-icon icon="info"></md-icon>
							Los usuarios con acceso al admin y su tipo de acceso sea <b>Master</b>, tienen acceso a
							cualquier proveedor.
						</b-alert>
						<hr>
						<b-form
							@submit="(evt) => { evt.preventDefault(); this.$root.$emit('bv::refresh::table', 'users-index-list') } ">
							<div class="row">
								<b-form-group class="col-2" label="Buscar">
									<b-form-input v-model="sassAppFilters.search" type="text"/>
								</b-form-group>
								<b-form-group class="col-2" label=".">
									<b-button type="submit" variant="primary">Buscar</b-button>
								</b-form-group>
							</div>
						</b-form>

						<AjaxTable
							permission-show="usersass.show"
							id="users-index-list"
							:filters="sassAppFilters"
							:columns="sassAppColumns"
							resource="users"
							responsive
						>
							<template v-slot:cell(access)="row">
								<b-badge v-if="row.item.sass == null" variant="secondary" class="mr-2">Sin plataforma</b-badge>
								<b-badge v-if="row.item.sass != null && row.item.sass.pos" variant="info" v-b-tooltip.hover v-b-tooltip.placement.auto :title="posList(row.item.sass)" class="mr-2">POS</b-badge>
								<b-badge v-if="row.item.sass != null && row.item.sass.suppliers" variant="warning" v-b-tooltip.hover v-b-tooltip.placement.right :title="suppliersList(row.item.sass)">Suppliers</b-badge>
							</template>
							<template v-slot:cell(actions)="row">
								<div class="text-center">
									<b-button @click="() => editUser(row.item.id, 'sass')" type="button" size="sm" class="mr-1" variant="info">
										<md-icon icon="edit"/>
									</b-button>
									<b-button v-if="$hasPermission('usersass.delete')" @click="(event) => userDelete(row.item,row.index,event)" type="button" size="sm" class="mr-1" variant="danger">
										<md-icon icon="delete"/>
									</b-button>
									<b-button
										v-if="$hasPermission('usersass.reset')"
										@click="event =>userResetPassword(row.item, row.index, event)"
										type="button"
										size="sm"
										class="mr-1"
										variant="warning"
									>
										<md-icon icon="lock" />
									</b-button>
								</div>
							</template>
						</AjaxTable>
					</b-tab>
				</b-tabs>
			</b-card>
		</div>
		<ResetPassword ref="resetPassword" />
		<Single :unableEdit="unableEditUser || unableEditUserSass" ref="single" :success-callback="successCallback"/>
	</MainLayout>
</template>

<script>
import MainLayout from '../layout/MainLayout.vue'
import AjaxTable from '../../helpers/AjaxTable.vue'
import Single from './Single.vue'
import api from '../../../api.js'
import ResetPassword from "./ResetPassword.vue"

export default {
	components: {MainLayout, ResetPassword, Single, AjaxTable},
	data() {
		return {
			modalInfo: {
				modelId: -1,
				title: "Usuario",
			},
			coreAppFilters: {
				app: 'core',
				search: '',
			},
			sassAppFilters: {
				app: 'sass',
				search: '',
			},
			unableEditUser: false,
			unableEditUserSass: false,
			usersColumns: [
				{key: 'id', label: 'ID'},
				{key: 'firstName', label: 'Nombre'},
				{key: 'email', label: 'Email'},
				{key: 'app', label: 'Aplicación'},
				{key: 'accessType', label: 'Acceso'},
				{key: 'status', label: 'Estado'},
				{key: 'actions', label: 'Acciones'},
			],
			sassAppColumns: [
				{key: 'id', label: 'ID'},
				{key: 'firstName', label: 'Nombre'},
				{key: 'email', label: 'Email'},
				{key: 'app', label: 'Aplicación'},
				{key: 'access', label: 'SASS'},
				{key: 'accessType', label: 'Acceso'},
				{key: 'status', label: 'Estado'},
				{key: 'actions', label: 'Acciones'},
			],
		}
	},
	computed: { },
	methods: {
		userResetPassword(item){
			this.$refs["resetPassword"].loadModel(item.id)
		},
		successCallback() {
			this.$root.$emit('bv::refresh::table', 'users-index-list')
		},
		editUser(id, type){
			if(type === 'core'){
				this.unableEditUser = !this.$hasPermission('user.edit')
				this.unableEditUserSass = false
			}else{
				this.unableEditUserSass = !this.$hasPermission('usersass.edit')
				this.unableEditUser = false
			}
			this.$refs['single'].loadModel(id, type)
		},
		newUser(app) {
			this.$refs['single'].loadModel(-1, app)
			this.$refs['single'].setApp(app)
		},
		userDelete(item) {
			this.$root.showWarning({
				okAction: (event, setLoading, close) => {
					setLoading(true)
					api(this).delete(`/users/${item.id}`).then(() => {
						this.$root.showAlert('Registro Eliminado!', {variant: 'warning'})
						this.$root.$emit('bv::refresh::table', 'users-index-list')
						close()
					}).catch(err => {
						this.$root.handleRequestError(err)
						close()
					});
				}
			})
		},
		posList(data) {
			let tooltip = ''
			let pos = data.pos?.map(i => ({
				text: i.codename
			}))
			pos?.forEach(i => {
				tooltip += i.text + ', '
			})
			return tooltip
		},
		suppliersList(data) {
			let tooltip = ''
			let suppliers = data.suppliers?.map(i => ({
				text: i.code
			}))

			suppliers?.forEach(i => {
				tooltip += i.text + ', '
			})

			return tooltip
		}
	},
	mounted() {
	}
}
</script>

<style>

</style>
